import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-4 py-3 text-gray-500 text-xs w-max" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-6 gap-x-4 items-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Волна"),
  /*#__PURE__*/_createElementVNode("div", null, "Сектор"),
  /*#__PURE__*/_createElementVNode("div", null, "Авто"),
  /*#__PURE__*/_createElementVNode("div", null, "Стопы"),
  /*#__PURE__*/_createElementVNode("div", null, "Физ вес"),
  /*#__PURE__*/_createElementVNode("div", null, "Объемный вес")
], -1)
const _hoisted_3 = { class: "text-black font-semibold" }
const _hoisted_4 = { class: "text-black font-semibold" }
const _hoisted_5 = { class: "text-black font-semibold" }
const _hoisted_6 = { class: "text-black font-semibold" }
const _hoisted_7 = { class: "text-black font-semibold" }
const _hoisted_8 = { class: "text-black font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Подробнее",
    overflow: true,
    loading: _ctx.loading,
    onCancel: _ctx.onCancel,
    "without-footer": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cars, (car, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `PredictionCar-${i}`,
            class: "grid grid-cols-6 gap-x-4 items-center mt-6"
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(car.waveTitle), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(car.sectorName || 'Вне сектора'), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.getClass(car.truck ? car.truck.carCount : 0))
              }, " Грузовое: " + _toDisplayString(car.truck ? car.truck.carCount : 0), 3),
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.getClass(car.passanger ? car.passanger.carCount : 0))
              }, " Легковое: " + _toDisplayString(car.passanger ? car.passanger.carCount : 0), 3)
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(car.stopsCount), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(car.weight) + " кг", 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(car.volumeWeight) + " кг", 1)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["loading", "onCancel"]))
}